import { memo } from 'react';
import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import { getToolbarType } from 'redux/PlannerModeSlice';
import BuilderModeDataTableOpzV2 from 'pages/BuilderMode/BuilderModeDataTableOpzV2';

// import BuilderModeDataTableOpz from 'pages/BuilderMode/BuilderModeDataTableOpz';
import BuilderModeMapTabV1 from '../mapTab/BuilderModeMapTabV1';
import BuilderModeDataTableV1 from '../dataTable/BuilderModeDataTableV1';
import BuilderModePropertyTableV1 from '../propertyTable/BuilderModePropertyTableV1';

const BuilderModeMainPanelV1 = ({ flags }: any) => {
  const toolbarType = useSelector(getToolbarType) as 'Property' | 'Data' | 'Map';

  if (toolbarType === 'Data') {
    return (
      <Box flex='1' minH={0} h='100%' overflow='hidden' display='flex' flexDirection='column'>
        {flags?.builderModeTable ? <BuilderModeDataTableV1 /> : <BuilderModeDataTableOpzV2 />}
      </Box>
    );
  }

  if (toolbarType === 'Map') {
    return (
      <Box flex='1' minH={0} h='100%' overflow='hidden' display='flex' flexDirection='column'>
        <BuilderModeMapTabV1 />
      </Box>
    );
  }

  // Default: Property
  return (
    <Box flex='1' minH={0} h='100%' overflow='hidden' display='flex' flexDirection='column'>
      <BuilderModePropertyTableV1 />
    </Box>
  );
};

export default withLDConsumer()(memo(BuilderModeMainPanelV1));
